var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('pi-cell-row',{attrs:{"name":"账户信息"},on:{"click":_vm.accoutnInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }